export function formatRetryAfter(value) {
    if (!Number.isFinite(value) || value <= 0) {
        return null;
    }

    if (value < 60) {
        return `${Math.ceil(value)} seconds`;
    }

    const minutes = Math.ceil(value / 60);

    return minutes === 1 ? '1 minute' : `${minutes} minutes`;
}

export function formatExportAvailability(expiresAt) {
    if (typeof expiresAt !== 'string' || expiresAt.trim() === '') {
        return '';
    }

    const parsed = new Date(expiresAt);
    if (Number.isNaN(parsed.getTime())) {
        return '';
    }

    const hours = String(parsed.getHours()).padStart(2, '0');
    const minutes = String(parsed.getMinutes()).padStart(2, '0');

    return `available until ${hours}:${minutes}.`;
}

export function normalizeDownloadUrl(value) {
    if (typeof value !== 'string') {
        return null;
    }

    const normalized = value.trim();
    if (!normalized.startsWith('/account/export/download/')) {
        return null;
    }

    try {
        const parsed = new URL(normalized, 'https://casualer.local');
        const token = parsed.pathname.slice('/account/export/download/'.length);

        if (token === '' || !/^[A-Za-z0-9_-]+$/.test(token) || parsed.hash !== '') {
            return null;
        }

        return `${parsed.pathname}${parsed.search}`;
    } catch (error) {
        console.error(error);

        return null;
    }
}
